import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Paragraph.scss';

const Paragraph = ({ content, attrs = {}, isAccordianContent = false, article = false }) => {
	if (!content) return null;
	const style = {};
	const classes = [s.paragraph];
	let rawText = content.rawText;
	if (article === 'style') classes.push(s.paragraph__style);
	if (article === 'story') {
		classes.push(s.paragraph__story);
		rawText = rawText.replace(/\.?$/, '… ');
	}
	if (attrs.align || attrs.textAlign) style.textAlign = attrs.textAlign || attrs.align;
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textTransform) style.textTransform = attrs.textTransform;
	if (attrs.fontSize) classes.push(`u_fontSize__${attrs.fontSize}`);
	if (isAccordianContent) classes.push(s.paragraph__accordian);
	if (attrs.fontWeight && parseInt(attrs.fontWeight, 10) < 400) classes.push(s.paragraph__light);

	return (
		<p className={classes.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(rawText, { ADD_ATTR: ['target'] }) }} style={style} />
	);
};

export default hot(module)(Paragraph);
